import React from "react";
import classes from "../../assets/styles/Forms/SettingsInput.module.css";
import FormInput from "./FormInput";

const SettingsInput = ({ label, ...props }) => {
  return (
    <>
      {/* <div>
        <label htmlFor="" className="label mb-2">
          {label}
        </label> */}
      <FormInput {...props} label={label} />
      {/* </div> */}
    </>
  );
};

export default SettingsInput;
